import { useRoutes } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { SnackbarProvider } from 'notistack';
import SnackbarCloseButton from 'src/components/SnackbarCloseButton';
import router from 'src/router';

import { FlowProvider } from './contexts/FlowContext';
import { SonioDemoFlowFilterProvider } from './contexts/SonioDemoFlowFilterContext';
import ThemeProvider from './theme/ThemeProvider';

import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

const App = () => {
  const content = useRoutes(router);
  return (
    <ThemeProvider>
      <FlowProvider>
        <SonioDemoFlowFilterProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SnackbarProvider
            maxSnack={6}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            action={snackbarId => (
              <SnackbarCloseButton snackbarId={snackbarId} />
            )}
          >
            <CssBaseline />
            {content}
          </SnackbarProvider>
        </LocalizationProvider>
        </SonioDemoFlowFilterProvider>
      </FlowProvider>
    </ThemeProvider>
  );
};
export default App;
